import { StarRating } from "./StarRating";

export interface Props {
	score?: number;
	maxScore: number;
	oneline: boolean;
	visible: boolean;
	readonly?: boolean;
	onUpdate?: (score: number) => void;
}

export function TraitScore(props: Props) {
	if (!props.visible) return null;

	const message = props.score ? `You scored ${props.score} out of ${props.maxScore}` : `Unscored`;
	const classes = props.oneline ? "inline-block ml-36 mt-1" : "block relative";

	const handleUpdate = (score: number) => {
		props.onUpdate && props.onUpdate(score);
	};

	return (
		<div>
			<StarRating
				score={props.score ?? 0}
				stars={props.maxScore}
				readonly={props.readonly ?? true}
				onUpdate={handleUpdate}
			/>
			<div className={classes}> {message}</div>
		</div>
	);
}
